import React, {FC} from "react";
import {ProjectVisitSearch} from "../components/ProjectVisits/ProjectVisitSearch";
import {useApi} from "../api/APIContext";

export const Werkbezoeken: FC<{}> = (props) => {
  const { projectVisits } = useApi()
  return <main className={"flex-1 overflow-y-scroll max-h-[calc(100vh-4rem)]"}>
    <ProjectVisitSearch projectVisits={projectVisits ?? []} />
  </main>
}